import {
  SchemaDefinition,
  SchemaTransformError,
  UnknownSchema
} from '@rehaje/core'

import type { ActionSpecific } from './TypedNode'
import type { TypedSchema } from '@rehaje/core'

export interface SchemaActionSpecific extends RehajeSchemaMetadata {
  /**
   * 动作默认配置
   */
  default?: ActionSpecific
  type: 'Schema.Action'
  /**
   * 值
   */
  value?: any
}

export class SchemaActionDefinition extends SchemaDefinition {
  override defaultsMerge(
    value: any,
    schema: SchemaActionSpecific,
    initialize: boolean
  ) {
    if (initialize) {
      if (value === undefined) return schema.default
      return value
    }
    if (schema.required && value === undefined) {
      return schema.default
    }
    return value
  }

  override getIn(
    schema: SchemaActionSpecific,
    path: PropertyKey[]
  ): TypedSchema {
    if (path.length === 0) return schema
    return this.definition?.getPropertySchemaIn(path) ?? UnknownSchema
  }

  override infer(
    target: any,
    schema: SchemaActionSpecific
  ): SchemaActionSpecific {
    return this.inferOnlySchema({ ...schema, value: target })
  }

  override inferOnlySchema(schema: SchemaActionSpecific) {
    return schema
  }

  override inferTypeScript(schema: SchemaActionSpecific): string {
    if (typeof schema.value === 'function') return 'Function'
    return this.interface
  }

  override prune(target: any): any {
    return target
  }

  override transform(
    target: any,
    schema: SchemaActionSpecific,
    path: PropertyKey[] = []
  ) {
    if (this.test(target, schema, path)) return target
    if (target !== schema.fallback)
      this.raise(new SchemaTransformError(schema.name))
    return target
  }

  override validate(target: any, schema: SchemaActionSpecific) {
    this.validateMetadata(target, schema, (target) => {
      return typeof target === 'function' || this.isRelationSpecific(target)
    })
  }
}

declare global {
  export interface RehajeSpecifics {
    'Schema.Action': SchemaActionSpecific
  }
}
